import { defineStore } from 'pinia'

export const useSettingsStoreStore = defineStore('SettingsStoreStore', {
  state: () => {
    return {
      settings: {
        flow_company_uuid: null,
        google_recaptcha_key: null,
        site_url_api: null,
        flow_url_app: null,
        flow_url_api: null,
      }
    }
  },
  // could also be defined as
  // state: () => ({ count: 0 })
  actions: {

    setSettings(settings) {
      this.settings = settings;
    }
  },
})